module.exports = __webpack_public_path__ + "static/media/wineList.1800f967.pdf";